import React from "react";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { withRouter } from "react-router-dom";

function EditRequestDropdown(props) {
  const { DeleteRequest } = props;

  const handleDeleteRequest = () => {
    document.getElementById("close-popup").click();
    DeleteRequest();
  };
  return (
    <>
      <span className="dropdown">
        <MoreVertIcon
          className="float-right dropdown-toggle pointer-point mr-2 pb-1"
          style={{ color: "white" }}
          data-toggle="dropdown"
        />
        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a
            className="dropdown-item"
            style={{
              color: "#747474",
              fontSize: "15px",
              cursor: "pointer",
            }}
            data-toggle="modal"
            data-target="#delete-req-modal"
            onClick={() => {}}
          >
            Cancel
          </a>
        </div>
      </span>

      <div
        className="modal fade"
        id="delete-req-modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="logout-title"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content pb-30">
            <div className="modal-header text-center border-0 pb-0">
              <button
                type="button"
                className="close black-color"
                data-dismiss="modal"
                aria-label="Close"
                id="close-popup"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="form-wrapper pl-4 pr-4 pl-sm-5 pr-sm-5">
              <div className="modal-body p-0">
                <div className="text-center pb-4">
                  <span className="black-color text-center ">
                    <h5 className="text-center" id="logout-title">
                      Delete Request
                    </h5>
                    <p className="text-center sub-title pb-2 mb-1 pt-4">
                      Are your sure you want to delete this request?
                    </p>
                  </span>
                </div>
                <div className="row justify-content-center text-center">
                  <div className="col-6">
                    <button
                      onClick={handleDeleteRequest}
                      className="custom-btn-small custom-buton float-right"
                    >
                      Yes
                    </button>
                  </div>
                  <div className="col-6">
                    <button
                      data-dismiss="modal"
                      aria-label="Close"
                      className="custom-btn-small custom-buton custom-button-pink float-left"
                      // onClick={closeModel}
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default withRouter(EditRequestDropdown);
